import { enterFullscreen, exitFullscreen, observeFullscreen } from 'bits/fullscreen'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'

@Component
export default class extends Vue {
  private unobserveFullscreen
  @State private isFullscreen
  @Action private enterFullscreen
  @Action private exitFullscreen

  @Watch('isFullscreen')
  private updateFullscreen(): void {
    this.isFullscreen ? enterFullscreen() : exitFullscreen()
  }

  private observeFullscreenHandler(enteringFullscreen: boolean): void {
    const exitingFullscreen = !enteringFullscreen
    if (!this.isFullscreen && enteringFullscreen) this.enterFullscreen()
    if (this.isFullscreen && exitingFullscreen) this.exitFullscreen()
  }

  private mounted(): void {
    this.unobserveFullscreen = observeFullscreen(this.observeFullscreenHandler)
  }

  private beforeDestroy(): void {
    this.unobserveFullscreen && this.unobserveFullscreen()
  }
}
